import React from "react";
import CategoryProductList from "./CategoryProductList";

export const Clutch_System = () => {
  return (
    <CategoryProductList
      categoryName="Clutch System"
      categorySlug="clutch"
    />
  );
};

export default Clutch_System;
